"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmptyScoreProof = exports.getScoreProof = void 0;
var ethers_1 = require("ethers");
function getScoreProof(score, creditScoreTreeToCheck) {
    return __assign(__assign({}, score), { merkleProof: creditScoreTreeToCheck.getProof(score) });
}
exports.getScoreProof = getScoreProof;
function getEmptyScoreProof(account, protocol) {
    if (protocol === void 0) { protocol = ethers_1.utils.formatBytes32String(''); }
    return {
        account: account || ethers_1.constants.AddressZero,
        protocol: protocol,
        score: ethers_1.BigNumber.from(0),
        merkleProof: [],
    };
}
exports.getEmptyScoreProof = getEmptyScoreProof;
